import './formGroup.scss';

const FormGroup = ({ label, subtitle = '', required = false, children }) => {
  return (
    <div className="form-group">
      <section className="label-wrapper">
        <span>{label}{`${required ? ' *' : ''}`}</span>
        <span className="subtitle">{subtitle}</span>
      </section>
      <section className="input-wrapper">{children}</section>
    </div>
  );
};

export default FormGroup;
